import { USER_TYPES } from "../constants/userTypes";
import { useCustomUserProfile } from "./customUserProfile";

export const usePermissions = () => {
  const { profile, isLoading } = useCustomUserProfile();

  const userType = profile?.user_type;

  return {
    isLoading,

    isAdmin: userType === USER_TYPES.ADMIN,
    isManager: userType === USER_TYPES.MANAGER,
    isCarer: userType === USER_TYPES.CARER,
    isSupervisor: userType === USER_TYPES.SUPERVISOR,
    isUser: userType === USER_TYPES.USER,

    hasPermission: (roles = []) => {
      if (!userType) return false;
      return roles.includes(userType);
    },
  };
};